<template>
  <div class="mt-4">
    <form @submit.prevent="onSubmit" class="flex flex-col items-start">
      <label
        for="email"
        class="text-sm font-medium text-gray-700 whitespace-nowrap"
      >
        Credits
      </label>
      <div class="mt-1 w-full">
        <NumberInput
          v-model="amount"
          @input="formActions.clearFormErrors"
          required
        />
        <p class="text-red-500 text-sm mt-1">{{ errors.amount }}</p>
      </div>
      <label
        for="creditType"
        class="text-sm font-medium text-gray-700 whitespace-nowrap mt-4"
      >
        Credit Type:
      </label>
      <div class="mt-1 w-full">
        <select
          id="creditType"
          class="form-field-no-icon sm:w-full"
          v-model="creditType"
          @change="formActions.clearFormErrors"
        >
          <option v-for="option in creditTypeOptions" :key="option" :value="option">
            {{ option }}
          </option>
        </select>
        <p class="text-red-500 text-sm mt-1">{{ errors.credit_type }}</p>
      </div>
      <label
        for="pricePerCredit"
        class="text-sm font-medium text-gray-700 whitespace-nowrap mt-4"
      >
        Price Per Credit:
      </label>
      <div class="mt-1 w-full">
        <NumberInput
          v-model="pricePerCredit"
          @input="formActions.clearFormErrors"
          :decimals="5"
          :min="0"
          placeholder="0.00"
          required
        />
        <p class="text-red-500 text-sm mt-1">{{ errors.price_per_credit }}</p>
      </div>
      <label
        for="adminCreditDetails"
        class="text-sm font-medium text-gray-700 whitespace-nowrap mt-4"
      >
        Credit Details:
      </label>
      <div class="mt-1 w-full">
        <input
          id="adminCreditDetails"
          type="text"
          v-model="adminCreditDetails"
          class="form-field-no-icon sm:w-full outline-none"
          @input="formActions.clearFieldError('admin_credit_details')"
        />
        <p class="text-red-500 text-sm mt-1">{{ errors.admin_credit_details }}</p>
      </div>
      <button
        type="submit"
        :disabled="Object.keys(errors).length > 0"
        class="button-submit mt-5"
      >
        Confirm
      </button>
    </form>
  </div>
</template>
<script>
import { ref } from "vue";
import NumberInput from "@/components/common/NumberInput";
import formMixin from "@/mixins/formMixin";
import eventBus from "@/utils/eventBus";
import useFormErrors from "@/api/formErrors";
import useConfirmationModal from "@/api/confirmationModal";

export default {
  name: "UserCreditsBalanceAdminForm",
  mixins: [formMixin],
  props: {
    userId: Number,
    default: null,
  },
  components: {
    NumberInput,
  },
  setup() {
    const { errors, formActions } = useFormErrors();
    const amount = ref(0);
    const pricePerCredit = ref(null);
    const creditType = ref(null);
    const adminCreditDetails = ref("");
    const creditTypeOptions = ref([
      "Free",
      "Invoiced Offline",
      "Purchased with Plan",
    ]);


    return {
      amount,
      pricePerCredit,
      creditType,
      adminCreditDetails,
      creditTypeOptions,
      errors,
      formActions,
    };
  },
  methods: {
    async onSubmit() {
      const modal = useConfirmationModal();
      await modal.openModal({
        title: "Are you sure you want to confirm?",
        message: `This action will add ${this.amount} free credits to the user's account at ${this.pricePerCredit} per credit`,
        onSubmit: () => this.handleAddUserCreditsBalance(),
      });
    },
    async handleAddUserCreditsBalance() {
      const response = await this.handleSubmissionErrors(
        () =>
          this.$alfredService.addUserCreditsBalance({
            amount: this.amount,
            user: this.userId,
            price_per_credit: this.pricePerCredit,
            credit_type: this.creditType,
            admin_credit_details: this.adminCreditDetails,
          }),
        { formActions: this.formActions, throwExceptions: false }
      );
      if (response) {
        const credit_balance = await this.$alfredService.adminUserCreditsBalance(this.userId);
        eventBus.trigger("notify", {
          notification: {
            group: "top-right",
            type: "success",
            text: response["detail"],
          },
        });
        document.getElementsByName(
          "user-balance"
        )[0].innerHTML = `${credit_balance.credits} Credits`;
      }
    },
  },
};
</script>
